// extracted by mini-css-extract-plugin
export var awards = "IconItem-module--awards--b9a9a";
export var fadeInAnimation = "IconItem-module--fadeInAnimation--88da8";
export var icon = "IconItem-module--icon--256a4";
export var img = "IconItem-module--img--ed4b3";
export var link = "IconItem-module--link--4bed2";